export enum PartnersStatuses {
  /**
   * Партнёр
   */
  PARTNER = 'partner',
  /**
   * Мастер-партнёр
   */
  MASTER_PARTNER = 'master_partner',
  /**
   * Премиум-партнёр
   */
  PREMIUM_PARTNER = 'partner_partner',
  /**
   * Дистрибьютор
   */
  DISTRIBUTOR = 'distributor',

   /**
   * Розничная цена
   */
   RETAIL_PRICE = 'retail',
}

export const PartnersStatusesTranslate = {
  [PartnersStatuses.PARTNER]: 'Бронза',
  [PartnersStatuses.MASTER_PARTNER]: 'Мастер-партнёр',
  [PartnersStatuses.PREMIUM_PARTNER]: 'Серебро',
  [PartnersStatuses.DISTRIBUTOR]: 'Золото',
  [PartnersStatuses.RETAIL_PRICE]: 'Розничная цена',
};
